export default __webpack_public_path__ + "static/media/icon-circular-geofence.cf631d0c.svg";